export default __webpack_public_path__ + "static/media/block-website-category.8ba7a762.png";